// extracted by mini-css-extract-plugin
export var copyableField = "_pv-4";
export var customerBadge = "_pv-0";
export var customerInfoTitle = "_pv-2";
export var details = "_pv-1";
export var dropdownContainer = "_pv-5";
export var dropdownImage = "_pv-6";
export var editAssigneeForm = "_pv-a";
export var editButton = "_pv-3";
export var email = "_pv-7";
export var hidden = "_pv-d";
export var input = "_pv-8";
export var saveButton = "_pv-b";
export var shopifyIcon = "_pv-c";
export var suggestionBadge = "_pv-e";
export var suggestionText = "_pv-f";
export var username = "_pv-9";